module.exports = __webpack_public_path__ + "static/media/Children.75d50e56.jpg";